import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { FAQEdit, FAQReadOnly } from './FAQForm';

export default function FaqPage({}: any) {
  return (
    <GenericCrudPage
      key='faq-page'
      tableColumns={[
        {
          field: 'question',
          headerName: 'Question',
          width: 200,
        },
        {
          field: 'createdBy',
          headerName: 'Author',
          width: 200,
        },
      ]}
      singularName='faq'
      pageTitle='FAQs'
      resource='faq'
      allowAdd={true}
      allowEdit={true}
      allowDelete={true}
      ReadOnlyComponent={FAQReadOnly}
      EditFormComponent={FAQEdit}
      newPayload={{
        question: '',
        answer: '',
        order: 0,
      }}
      validateFn={(data: any) => {
        return [true, []];
      }}
    />
  );
}
